/* Load as a theme asset, once. No Meta event is emitted here. */
(function () {
  'use strict';
  if (window.__itkCaptureV2) return;
  window.__itkCaptureV2 = true;
  var cfg = window.ITKANE_CAPTURE_CONFIG || {};
  var endpoint = cfg.endpoint;
  if (!endpoint || !/^https:\/\//.test(endpoint)) { console.warn('ITKANE: endpoint missing'); return; }
  if(!/^[a-z0-9][a-z0-9-]{2,39}$/.test(cfg.deploymentId||'')){console.warn('ITKANE: deploymentId missing');return;}
  var storageKey = 'itkane_visit_v3_'+cfg.deploymentId, record = null, sent = '', busy = false;
  var attempts = 0, timer = null, enabled = false, started = 0, generation=0, sdkFlow=null, sdkValues=null;
  function allowed() {
    try { return window.Shopify.customerPrivacy.marketingAllowed() === true; } catch (_) { return false; }
  }
  function cookie(name) {
    var parts = document.cookie.split(';');
    for (var i=0;i<parts.length;i++) {
      var row=parts[i].trim(),eq=row.indexOf('=');
      if(row.slice(0,eq)===name){try{return decodeURIComponent(row.slice(eq+1));}catch(_){return null;}}
    }
    return null;
  }
  function save(){try{localStorage.setItem(storageKey,JSON.stringify(record));}catch(_){/* page memory remains usable */}}
  function identity() {
    var u=new URL(window.location.href),click=u.searchParams.get('fbclid');
    if(!record){try{record=JSON.parse(localStorage.getItem(storageKey));}catch(_){} }
    if(!record || !/^[-a-zA-Z0-9]{20,80}$/.test(record.id||'') || !Number.isFinite(record.at) || record.at>Date.now()+300000 || Date.now()-record.at>30*86400000 || (click&&click!==record.click)) {
      if(record&&click&&record.click!==click){generation++;sdkFlow=null;sdkValues=null;}
      record={id:crypto.randomUUID(),click:click||null,at:Date.now()};save();
    }
    // Never adopt a visit_id supplied in a shared link. Use this browser's own id.
    if(cfg.decorateUrl!==false&&u.searchParams.get('itk_attr_id')!==record.id){
      u.searchParams.set('itk_attr_id',record.id);
      try{history.replaceState(history.state,'',u.toString());}catch(_){}
    }
    return record;
  }
  function schedule(delay){clearTimeout(timer);if(enabled&&attempts<12&&Date.now()-started<90000)timer=setTimeout(tick,delay);}
  async function tick(){
    if(!enabled||!allowed())return;
    var r=identity();runBuilder();if(busy){schedule(250);return;}
    var fbc=cookie('_fbc')||(sdkValues&&sdkValues._fbc),fbp=cookie('_fbp')||(sdkValues&&sdkValues._fbp);
    var payload={deployment_id:cfg.deploymentId,visit_id:r.id,fbclid:r.click,fbc:fbc||null,fbp:fbp||null,consent:true};
    var signature=JSON.stringify(payload);
    if(signature===sent){schedule(2000);return;}
    busy=true;attempts++;
    var controller=new AbortController(),timeout=setTimeout(function(){controller.abort();},8000);
    try{
      var response=await fetch(endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:signature,keepalive:true,signal:controller.signal});
      var result=response.ok?await response.json():null;
      if(!response.ok||!result||result.ok!==true||result.visit_id!==r.id)throw new Error('CAPTURE_NOT_ACKNOWLEDGED');
      sent=signature;
      window.__itkCaptureStatus={state:'saved',has_fbc:!!fbc,has_fbp:!!fbp};
      schedule(2000);
    }catch(_){
      window.__itkCaptureStatus={state:'retry_pending',attempt:attempts};
      schedule(Math.min(15000,500*Math.pow(2,Math.min(attempts,5))));
    }finally{clearTimeout(timeout);busy=false;}
  }
  function runBuilder(){
    var g=generation;
    if(sdkFlow===g)return;sdkFlow=g;
    function collect(){
      if(!allowed()||!enabled||g!==generation)return;
      var sdk=window.clientParamBuilder;
      if(!sdk||typeof sdk.processAndCollectAllParams!=='function')return;
      // Official SDK is the only writer of Meta cookies. No external getIpFn.
      Promise.resolve(sdk.processAndCollectAllParams(window.location.href)).then(function(values){
        if(allowed()&&enabled&&g===generation){sdkValues=values||null;schedule(0);}
      }).catch(function(){/* partial capture remains valid */});
    }
    if(window.clientParamBuilder){collect();return;}
    if(!cfg.sdkUrl)return;
    var tag=document.createElement('script');tag.src=cfg.sdkUrl;tag.async=true;
    tag.onload=collect;tag.onerror=function(){window.__itkBuilderStatus='unavailable';};
    document.head.appendChild(tag);
  }
  function start(){
    if(!allowed()){
      enabled=false;clearTimeout(timer);
      window.__itkCaptureStatus={state:'consent_not_available_or_denied'};
      return;
    }
    if(enabled)return;
    enabled=true;attempts=0;started=Date.now();tick();runBuilder();
  }
  document.addEventListener('visitorConsentCollected',function(){
    if(!allowed()){
      enabled=false;clearTimeout(timer);sent='';generation++;sdkFlow=null;sdkValues=null;
      // Best-effort withdrawal notification contains only this visit id.
      if(record)fetch(endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({deployment_id:cfg.deploymentId,visit_id:record.id,consent:false}),keepalive:true}).catch(function(){});
      record=null;
      try{localStorage.removeItem(storageKey);}catch(_){}
      var u=new URL(window.location.href);u.searchParams.delete('itk_attr_id');
      try{history.replaceState(history.state,'',u.toString());}catch(_){}
    }else start();
  });
  window.addEventListener('online',function(){if(allowed()){enabled=false;start();}});
  window.addEventListener('pageshow',function(){if(allowed()){enabled=false;start();}});
  // Resend new cookie values at order interactions; never intercept the WEBI form.
  document.addEventListener('submit',function(){if(allowed()){attempts=0;started=Date.now();tick();}},true);
  function boot(){
    if(window.Shopify&&window.Shopify.customerPrivacy){start();return;}
    if(window.Shopify&&window.Shopify.loadFeatures){
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){if(!error)start();else window.__itkCaptureStatus={state:'privacy_api_unavailable'};});
    }else window.__itkCaptureStatus={state:'privacy_api_unavailable'};
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
